import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import LandingPage from './components/LandingPage';
import SuccessPage from './components/SuccessPage';
import CancelPage from './components/CancelPage';
import EmailPreview from './components/EmailPreview';
import EmailTest from './components/EmailTest';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/donation-success" element={<SuccessPage />} />
          <Route path="/donation-cancelled" element={<CancelPage />} />
          <Route path="/email-preview" element={<EmailPreview />} />
          <Route path="/email-test" element={<EmailTest />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
